import { all } from 'redux-saga/effects';
import authSagas from './auth';
import noteSaga from './orderNoteSaga';
import photoSaga from './uploadPhotoSaga';
import benefitsSaga from './customerBenefitSaga';

export default function* rootSaga() {
  yield all([authSagas, photoSaga(), noteSaga(), benefitsSaga()]);
}
